import { render, staticRenderFns } from "./QualifiedAuthor.vue?vue&type=template&id=f4f81716"
import script from "./QualifiedAuthor.vue?vue&type=script&lang=js"
export * from "./QualifiedAuthor.vue?vue&type=script&lang=js"
import style0 from "./QualifiedAuthor.vue?vue&type=style&index=0&id=f4f81716&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports